import { create } from 'zustand';
import { devtools } from 'zustand/middleware';

type ErrorBoundaryStore = {
  resetBoundary: (() => void) | null;
  setResetBoundary: (resetBoundary: (() => void) | null) => void;

  lastRenderedId: string;
  setLastRenderedId: (lastRenderedId: string) => void;
};

const initialState = {
  resetBoundary: null,
  lastRenderedId: '',
};

export const useErrorBoundaryStore = create<ErrorBoundaryStore>()(
  devtools(
    set => ({
      ...initialState,
      setResetBoundary: (resetBoundary: (() => void) | null) => {
        set({ resetBoundary }, false, 'setResetBoundary');
      },
      setLastRenderedId: (lastRenderedId: string) => {
        set({ lastRenderedId }, false, 'setLastRenderedId');
      },
    }),
    {
      name: 'error-boundary-store',
    },
  ),
);
